import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/solid'
import type { MutationObserverResult, UseQueryResult } from 'react-query'
import { throwUnsupportedValue } from 'src/utils'
import { Spinner } from './Shared'

type Props = {
  status?: UseQueryResult['status'] | MutationObserverResult['status']
  label: string
}

export default function ListItem(props: Props) {
  return (
    <li className="flex flex-row items-center my-4">
      {getStatusIcon(props.status)}

      <p className="ml-4 text-base text-slate-700">{props.label}</p>
    </li>
  )
}

function getStatusIcon(status: Props['status']) {
  switch (status) {
    case undefined:
    case 'idle':
      return <div className="w-2 h-2 m-[.375rem] rounded-full bg-slate-300" />
    case 'loading':
      return <Spinner className="!w-5 !h-5" />
    case 'success':
      return <CheckCircleIcon aria-hidden className="w-5 h-5 text-slate-400" />
    case 'error':
      return (
        <ExclamationCircleIcon aria-hidden className="w-5 h-5 text-slate-400" />
      )
    default:
      throwUnsupportedValue(status)
  }
}
